import React from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'
import { venture } from '../config'

const componentList = {
  // Containers
  GamesRow: { name: 'GamesRow', type: 'container' },
  GameCarousel: { name: 'GameCarousel', type: 'container' },
  GamesRowExpandable: { name: 'GamesRowExpandable', type: 'container' },
  Tickers: { name: 'Tickers', type: 'container' },
  Hypertext: { name: 'UKGC', type: 'container' },
  LotteryResults: { name: 'LotteryResults', type: 'container' },
  BlueprintJackpots: { name: 'BlueprintJackpots', type: 'container' },
  NavigationMenu: { name: 'UnicornNavigationMenu', type: 'container' },
  UnicornNavigationMenu: { name: 'UnicornNavigationMenu', type: 'container' },
  Winners: { name: 'WinnersContainer', type: 'container' },
  DoubleJackpots: { name: 'DoubleJackpots', type: 'container' },
  BlogsGrid: { name: 'BlogsGrid', type: 'container' },
  BlogHighlights: { name: 'BlogHighlights', type: 'container' },
  PromoTileRow: { name: 'PromoTilesRow', type: 'container' },
  Content: { name: 'Content', type: 'container' },
  HeadlessJackpots: { name: 'HeadlessJackpots', type: 'container' },
  WelcomeOffer: { name: 'WelcomeOffer', type: 'container' },
  PreRegistrationForm: { name: 'PreRegistrationForm', type: 'container' },

  // Common-Components
  SubTitle: { name: 'SubTitle', type: 'common' },
  ZeroBanner: { name: 'ZeroBanner', type: 'common' },
  Steps: { name: 'Steps', type: 'common' },
  CallToAction: { name: 'CallToAction', type: 'common' },
  MiniBanner: { name: 'MiniBanner', type: 'common' },
  Introduction: { name: 'Introduction', type: 'common' },
  GameContent: { name: 'GameContent', type: 'common' },
  PageContent: { name: 'PageContent', type: 'common' },
  BullettedList: { name: 'BullettedList', type: 'common' },
  GameHero: { name: 'GameHero', type: 'common' },
  VideoBanner: { name: 'VideoBanner', type: 'common' },
  AlternatingTextAndImage: { name: 'AlternatingTextAndImage', type: 'common' },
  FWAlternatingTextAndImage: {
    name: 'FWAlternatingTextAndImage',
    type: 'common'
  },
  GameFeatures: { name: 'GameFeatures', type: 'common' },
  Icons: { name: 'Icons', type: 'common' },
  FullWidthImage: { name: 'FullWidthImage', type: 'common' },
  HeroStory: { name: 'HeroStory', type: 'common' },
  TopStory: { name: 'TopStory', type: 'common' },
  TopStories: { name: 'TopStories', type: 'common' },
  GameHeroTickerOverlay: { name: 'GameHeroTickerOverlay', type: 'common' },
  Spacer: { name: 'Spacer', type: 'common' },
  QuickReg: { name: 'QuickReg', type: 'common' },
  LottoSection: { name: 'LottoSection', type: 'common' },
  OtherPost: { name: 'OtherPost', type: 'common' },
  OtherPostsList: { name: 'OtherPostsList', type: 'common' },
  PostContent: { name: 'PostContent', type: 'common' },
  PostHeader: { name: 'PostHeader', type: 'common' },
  PostImage: { name: 'PostImage', type: 'common' },
  PostMeta: { name: 'PostMeta', type: 'common' },
  PostPage: { name: 'PostPage', type: 'common' },
  StepsWithImage: { name: 'StepsWithImage', type: 'common' },
  ImageBanner: { name: 'ImageBanner', type: 'common' },
  HeroAnimated: { name: 'HeroCanvas', type: 'common' },
  HeroStatic: { name: 'HeroCanvas', type: 'common' },
  HeaderSmall: { name: 'HeaderSmall', type: 'common' },
  SocialLink: { name: 'SocialLink', type: 'common' },
  WinnersCarousel: { name: 'WinnersCarousel', type: 'common' },
  AwardsCarousel: { name: 'AwardsCarousel', type: 'common' },
  FlatStatePicker: { name: 'FlatStatePicker', type: 'common' },
  BetOnYourSport: { name: 'BetOnYourSport', type: 'common' },
  DownloadAppCTA: { name: 'DownloadAppCTA', type: 'common' },
  BallyPromotion: { name: 'BallyPromotion', type: 'common' },
  BallyAcquisitionHeader: { name: 'BallyAcquisitionHeader', type: 'common' },
  FullWidthImageBanner: { name: 'FullWidthImageBanner', type: 'common' },
  Accordion: { name: 'Accordion', type: 'common' },
  SideMenu: { name: 'SideMenu', type: 'common' },
  NavigationBreadcrumb: { name: 'NavigationBreadcrumb', type: 'common' },

  // Contentful Components
  DxBanners: { name: 'DxBanners', type: 'contentful' }
}

const fetchComponent = (componentFromDictionary) => {
  if (!componentFromDictionary) {
    return false
  }
  const { type, name } = componentFromDictionary

  switch (type) {
    case 'container':
      return loadable(() => import(`containers/${name}/index.js`))
    case 'contentful':
    case 'common':
      return loadable(() =>
        import(`@albatross/common-components/dist/components/${name}`)
      )
    default:
      return null
  }
}

export default class ComponentSelector extends React.Component {
  render () {
    const {
      globalContent = [],
      game = {},
      customTermsAndConditions,
      components,
      pageFooterOverride = {},
      globalComponents,
      ConfigContxt,
      enableContentful,
      brand
    } = this.props

    let isNavMenuPresent = false

    components?.length && components.forEach((component) => {
      if (component.type === 'UnicornNavigationMenu' || component.type === 'NavigationMenu') {
        isNavMenuPresent = true
      }
    })

    return (
      <div>
        {components &&
          Array.isArray(components) &&
          components.map((component, i) => {
            const componentFromDictionary = componentList[component.type]
            const Component =
              fetchComponent(componentFromDictionary) ||
              componentList[component.type]
            const props = component.props || {}
            const templateProps = component.templateProps || {}
            for (const templateProp of Object.keys(templateProps)) {
              const template = templateProps[templateProp]
              props[templateProp] = template
            }
            if (Component) {
              return (
                <Component
                  key={i}
                  {...{
                    game,
                    globalContent,
                    globalComponents,
                    venture,
                    customTermsAndConditions,
                    pageFooterOverride,
                    ConfigContxt,
                    isNavMenuPresent,
                    enableContentful,
                    brand,
                    dropdownsList: globalContent.dropdownMenu,
                    ...props
                  }}
                />
              )
            }
            return <h1 key={i}>{component.type} Missing</h1>
          })}
      </div>
    )
  }
}

ComponentSelector.propTypes = {
  globalContent: PropTypes.object,
  globalComponents: PropTypes.object,
  game: PropTypes.object,
  ConfigContxt: PropTypes.object,
  components: PropTypes.array,
  customTermsAndConditions: PropTypes.string,
  pageFooterOverride: PropTypes.object,
  enableContentful: PropTypes.bool,
  brand: PropTypes.object
}
